<template>
  <MainTemplate>
    <div class="hotel container">
      <router-view></router-view>
    </div>
  </MainTemplate>
</template>

<script>
import MainTemplate from '@/templates/MainTemplate.vue'

export default {
  name: 'Hotel',
  components: { MainTemplate },
  methods: { }
}
</script>
